// extracted by mini-css-extract-plugin
module.exports = {"Root":"Vertical_Root__1yZ3z"};